import React, {Fragment} from 'react';
import { useAuth } from '../../Context/Context';
import { WavyLink } from "react-wavy-transitions";
import Portafolio from '../../Components/Portafolio';

import img0 from "../../Images/Servicios/SE/0.png"
import img1 from "../../Images/Servicios/SE/1.png"

import icon1 from "../../Images/Servicios/Iconos/6.png";
import icon2 from "../../Images/Servicios/Iconos/2.png";
import icon3 from "../../Images/Servicios/Iconos/3.png";
import icon4 from "../../Images/Servicios/Iconos/7.png"; 
import icon5 from "../../Images/Servicios/Iconos/8.png";
import icon6 from "../../Images/Servicios/Iconos/9.png";

import img2 from "../../Images/Servicios/Desarrollo/1.png"
import img3 from "../../Images/Servicios/Desarrollo/2.png"
import img4 from "../../Images/Servicios/Desarrollo/3.png"
import img5 from "../../Images/Servicios/Desarrollo/4.png"
import img6 from "../../Images/Servicios/Desarrollo/5.png"
import img7 from "../../Images/Servicios/Desarrollo/6.png"

import imgServiciosBlanco from "../../Images/servicios_blanco.png";

import Efectos from '../../Components/Efectos';
import Contacto from '../../Components/Contacto';


const SistemasEmpresariales = () => {
    const { direction, cambio } = useAuth();

    return(
        <Fragment>
            <div>
                <div className='fondo_servicio_3'>
                    <div >
                        <p className='sub_titulo_nv_4 cont_movil_1' style={{color:"#ffffff"}}>
                            <span className='titulo_nv_2 cont_movil_2' style={{color:"#B5FCFD"}}>
                                Sistemas empresariales <br/>
                            </span>
                            Aumenta tu productividad
                        </p>
                        <div className='cont_5'>
                            <p>
                                Nuestros sistemas ERP están diseñados para automatizar 
                                los procesos de tu empresa (área de finanzas, comercial, logística, 
                                producción, etc). 

                            </p>
                            <p>
                                Su misión es facilitar la planificación de todos los recursos inicia tu 
                                digitalización empresarial.
                            </p>
                        </div>
                    </div>
                    <div>
                        {window.screen.width <= 550 ? (
                            <Efectos activado={true}>
                                <img className='scroll-element js-scroll fade-in-bottom' src={img0} alt="" style={{width:"85%", maxWidth:"1485px"}}/>
                            </Efectos>
                        ) : (
                            <Efectos activado={true}>
                                <img className='scroll-element js-scroll fade-in-bottom' src={img1} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                            </Efectos>
                        )}
                    </div>
                </div>

                <p className='center cont_1' style={{color:"#707070"}}>
                    Unifica y ordena toda la información de tu empresa <b>en un solo lugar, obtén todo el control en un solo sistema único y expandible.</b> 
                </p>
                <div className='cont_2'>
                    <p className='titulo_nv_1 center' style={{color:"#BF1F60"}}>
                        ¿Qué incluye?
                    </p>
                    <div style={{display:"flex", justifyContent:"space-evenly", flexWrap:"wrap", alignItems:"stretch"}}>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon1} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Accede desde la nube
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Podrás acceder a tu sistema desde cualquier computadora sí adquieres el plan en la nube
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon3} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Diseño personalizado
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Todos nuestros diseños son únicos, personalizados, atractivos y sobre todo funcionales.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon5} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Admin. del sistema
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Creamos un panel administrativo para que puedas utilizar todas las funcionalidades correctamente.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon2} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Optimización interna
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Protegemos todos los datos que se recaben en tu sitio gracias al protocolo de seguridad 
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon4} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Capacitación del sistema
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Ofrecemos capacitación completa del sistema para que puedan utilizarlo sin complicaciones.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon6} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Mantenimiento
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Estamos atentos con actualizaciones y resolución de cualquier bug que se pueda presentar.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{display:"flex", justifyContent:"center"}}>
                    <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                        <p class="btn_1" onClick={cambio} style={{margin:"0px", color:"#fff"}}>
                            Cotiza tu proyecto
                        </p>
                    </WavyLink>
                    {/* <div className='btn_1'>
                        <a href="/contacto" style={{color:"#fff"}}>
                            <p>
                                Cotiza tu proyecto
                            </p>
                        </a>
                    </div> */}
                </div>

                <div className='center'>
                    <p className='titulo_nv_1' style={{marginBottom:"0"}}>
                        ¿Cómo hacemos tu <br/>
                        <span className='titulo_nv_2' style={{color:"#A741AF"}}>sistema ERP?</span>
                    </p>
                    <p className='cont_7 cont_7_1' style={{color:"#707070"}}>
                        El proceso de trabajo de nuestros 
                        <b style={{color:"#BF1F60"}}> sistemas empresariales </b> 
                        se divide en distintas etapas,
                        cada una tan importante como la anterior.
                    </p>
                </div>

                {window.screen.width <= 992 ? (
                    <div className='cont_2' style={{display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
                        <div className='box_3'>
                            <img src={img2} alt=""  className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#42D4FC" , margin:"0px"}}>
                                    Definición del proyecto.
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Primero platicamos contigo para saber la meta a 
                                    alcanzar con este proyecto, cubrir tus necesidades 
                                    y sobre todo tomar la esencia de tu empresa.<br/>
                                    Te damos la <b>cotización del proyecto.</b> 
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img3} alt=""  className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#2A79B0" , margin:"0px"}}>
                                    Diseño y experiencia
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestro equipo de diseño se encargará de crear 
                                    una experiencia visual única, limpia y atractiva, 
                                    priorizando la accesibilidad para todos los 
                                    usuarios. Te presentaremos <b> la visualización de 
                                    tu sistema</b> para que puedas personalizarla aún más, 
                                    antes de aprobarla.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img4} alt=""  className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#134263" , margin:"0px"}}>
                                    Desarrollo del sistema
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestros ingenieros con el uso de la <b> tecnología y los 
                                    lenguajes de programación más novedosos</b> desarrollan 
                                    el diseño y se enfocan en la correcta adaptación de los 
                                    procesos.  
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img5} alt=""  className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#A741AF" , margin:"0px"}}>
                                    Control de calidad
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    <b>Realizamos las pruebas</b> de uso y calidad para 
                                    asegurarnos de que él funcionamiento sea 
                                    óptimo y así garantizar el uso perfecto del sistema.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img6} alt=""  className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Entregamos tu sistema
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}> 
                                    Tu sistema estará disponible para tu equipo 
                                    de trabajo y será <b> totalmente funcional.</b> Además, 
                                    <b> ofrecemos una capacitación</b> para que puedas 
                                    dominarlo totalmente.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img7} alt=""  className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Soporte
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}> 
                                    Estamos aquí siempre que nos necesites, 
                                    ofrecemos permanente comunicación de 
                                    todo nuestro equipo para apoyarte en 
                                    cualquier situación.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='cont_2' style={{display:"flex", justifyContent:"center", marginTop:"50px"}}>
                        <div className='flex_lateral'>
                            <div className='box_3'>
                            </div>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#2A79B0" , margin:"0px"}}>
                                    Diseño y experiencia
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestro equipo de diseño se encargará de crear 
                                    una experiencia visual única, limpia y atractiva, 
                                    priorizando la accesibilidad para todos los 
                                    usuarios. Te presentaremos <b> la visualización de 
                                    tu sistema</b> para que puedas personalizarla aún más, 
                                    antes de aprobarla.
                                </p>
                            </div>
                            <div className='box_3'>
                                
                            </div>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#A741AF" , margin:"0px"}}>
                                    Control de calidad
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    <b>Realizamos las pruebas</b> de uso y calidad para 
                                    asegurarnos de que él funcionamiento sea 
                                    óptimo y así garantizar el uso perfecto del sistema.
                                </p>
                            </div>
                        </div>
                        <div className='flex_centro'>
                            <img src={imgServiciosBlanco} className="effect_fondo" alt="" style={{width:"100%"}} />
                            <div className='box_4'>
                                <div>
                                    <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                        Soporte 
                                    </b>
                                    <p style={{color:"#707070" , margin:"0px"}}> 
                                        Estamos aquí siempre que nos necesites, 
                                        ofrecemos permanente comunicación de 
                                        todo nuestro equipo para apoyarte en 
                                        cualquier situación.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_lateral'>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#42D4FC" , margin:"0px"}}>
                                    Definición del proyecto.
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Primero platicamos contigo para saber la meta a 
                                    alcanzar con este proyecto, cubrir tus necesidades 
                                    y sobre todo tomar la esencia de tu empresa. 
                                    Te damos la <b>cotización del proyecto.</b> 
                                </p>
                            </div>
                            <div className='box_3'>
                            </div>
                            <div  className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#134263" , margin:"0px"}}>
                                    Desarrollo del sitio web
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestros ingenieros con el uso de la <b> tecnología y los lenguajes de programación más novedosos</b> desarrollan el diseño y se enfocan en la correcta adaptación de los procesos.  
                                </p>
                            </div>
                            <div className='box_3'>
                                
                            </div>
                            <div  className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Entregamos tu sistema
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}> 
                                    Tu sistema estará disponible para tu equipo 
                                    de trabajo y será <b> totalmente funcional.</b> Además, 
                                    <b> ofrecemos una capacitación</b> para que puedas 
                                    dominarlo totalmente.
                                </p>
                            </div>
                        </div>
                        
                    </div>

                )}

                <Portafolio />
                <Contacto />

            </div>
        </Fragment>
    )
}

export default SistemasEmpresariales;